import utilStorage, { NotificationConsent } from '@src/shared/services/util-storage';
import generateContext, { createAction } from '..';

interface IPermissionConsentState {
  consent: NotificationConsent | null;
  grantType: "default" | "denied" | "granted",
  hideTemporary: boolean,
}

const initialState: IPermissionConsentState = {
  consent: utilStorage.getNotificationPermissionConsent(),
  grantType: utilStorage.getNotificationGrantType() || 'default',
  hideTemporary: false,
};

enum PermissionConsetActionType {
  SetPermissionConsent= 'SET_PERMISSION_CONSENT',
  SetNotificationGrantType = 'SET_NOTIFICATION_GRANT_TYPE',
  FlushPermissionConsent = 'FLUSH_PERMISSION_CONSENT',
  HideTemporaryPermissionScreen = 'HIDE_TEMP_PERMISSION_SCREEN'
}

const reducer = (
  state: IPermissionConsentState,
  action: { type: PermissionConsetActionType; payload?: any }
): IPermissionConsentState => {
  switch (action.type) {
    case PermissionConsetActionType.SetPermissionConsent:
      return {
        ...state,
        consent: action.payload,
      };

    case PermissionConsetActionType.SetNotificationGrantType:
        return {
            ...state,
            grantType: action.payload
        }
    case PermissionConsetActionType.HideTemporaryPermissionScreen:
        return {
            ...state,
            hideTemporary: true
        }
    default:
      return state;
  }
};

const [PermissionConsentCtxProvider, usePermissionConsentState, usePermissionConsentDispatch] =
  generateContext(reducer, initialState);

const usePermissionConsentActions = () => {
  const dispatch = usePermissionConsentDispatch();

  const setPermissionConsent = (payload: NotificationConsent) => {
    dispatch(createAction( PermissionConsetActionType.SetPermissionConsent, payload));
  };

  const setNotificationGrantType = (payload: NotificationPermission | undefined) => {
    dispatch(createAction(PermissionConsetActionType.SetNotificationGrantType,payload))
  }

  const setNotificationScreenAsTemp = () => {
    dispatch(createAction(PermissionConsetActionType.HideTemporaryPermissionScreen))
  }
 
  return {
    setPermissionConsent,
    setNotificationGrantType,
    setNotificationScreenAsTemp
  };
};

export { PermissionConsentCtxProvider, usePermissionConsentState, usePermissionConsentActions };
